import { useNavigate } from "react-router-dom";
import { Check, X } from "lucide-react";
import MarketingNav from "@/components/MarketingNav";
import Footer from "@/components/Footer";
import { PrimaryButton } from "@/components/brand";
import { PLANS } from "@/constants/routa";

export default function Pricing() {
  const navigate = useNavigate();
  const choose = (id) => navigate(`/register?plan=${id}`);

  return (
    <div className="min-h-screen bg-white" data-testid="pricing-page">
      <MarketingNav />

      <section className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 lg:py-24">
        <div className="flex items-center gap-4 mb-8">
          <span className="font-mono text-[11px] tracking-[0.18em] uppercase text-gray-400">[01] Merchant Plans</span>
          <span className="h-px w-16 bg-gray-300" />
          <span className="font-mono text-[11px] tracking-[0.18em] uppercase text-gray-400">Vancouver · Canada</span>
        </div>
        <div className="max-w-2xl">
          <h1 className="headline text-5xl lg:text-[4rem] text-[#0a0a0a]">
            Software that moves your <span className="text-orange-500">deliveries</span>.
          </h1>
          <p className="mt-6 text-base text-gray-500 leading-relaxed">
            Routa uses AI and intelligent routing to help your business find the fastest, most efficient
            way to deliver every order. Pick a plan and start dispatching.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
          {PLANS.map((p) => (
            <div
              key={p.id}
              data-testid={`plan-card-${p.id}`}
              className={`relative bg-white p-8 flex flex-col ${p.popular ? "lg:-my-4 lg:shadow-[0_0_0_2px_#f97316]" : ""}`}
            >
              {p.popular && (
                <span className="absolute top-0 right-0 bg-orange-500 text-white font-mono text-[10px] tracking-[0.14em] uppercase px-3 py-1.5">
                  Most Popular
                </span>
              )}
              <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-gray-400">{p.name}</div>
              <div className="mt-4 flex items-end gap-1">
                <span className="text-4xl font-bold tracking-tight text-[#0a0a0a]">${p.price}</span>
                <span className="text-sm text-gray-400 mb-1">/month</span>
              </div>
              <p className="mt-3 text-sm text-gray-500 leading-relaxed min-h-[40px]">{p.tagline}</p>

              <ul className="mt-6 space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-[#0a0a0a]">
                    <Check className="h-4 w-4 text-orange-500 mt-0.5 shrink-0" strokeWidth={2.4} />
                    {f}
                  </li>
                ))}
                {p.excluded.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-gray-400">
                    <X className="h-4 w-4 text-gray-300 mt-0.5 shrink-0" strokeWidth={2.4} />
                    {f}
                  </li>
                ))}
              </ul>

              <PrimaryButton
                orange={p.popular}
                arrow
                onClick={() => choose(p.id)}
                data-testid={`choose-plan-${p.id}`}
                className="mt-8 w-full"
              >
                Choose {p.name}
              </PrimaryButton>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#0a0a0a] py-20">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex flex-col lg:flex-row lg:items-center justify-between gap-8">
          <div>
            <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-white/40 mb-5">[02] Get Started</div>
            <h2 className="headline text-3xl lg:text-5xl text-white">Start delivering smarter today.</h2>
          </div>
          <PrimaryButton orange arrow data-testid="pricing-get-started" onClick={() => navigate("/register")} className="shrink-0">
            Get Started
          </PrimaryButton>
        </div>
      </section>

      <Footer />
    </div>
  );
}
